import React from 'react';

const Section7PartnerPrefs = ({ formData, handleChange }) => (
    <div className="fade-in">
        <h4 className="mb-3">7. Partner Preferences</h4>
        <div className="mb-3">
            <label className="form-label">Looking for in a Partner (Short Bio)</label>
            <textarea name="partnerBio" value={formData.partnerBio} onChange={handleChange} className="form-control" rows="4" placeholder="Describe the qualities you are looking for..."></textarea>
        </div>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Preferred Age Range</label>
                <input type="text" name="partnerAgeRange" value={formData.partnerAgeRange} onChange={handleChange} className="form-control" placeholder="e.g., 25-30 years" />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Preferred Location</label>
                <input type="text" name="partnerLocation" value={formData.partnerLocation} onChange={handleChange} className="form-control" placeholder="e.g., Pune, Mumbai, Open to Relocate" />
            </div>
        </div>
    </div>
);

export default Section7PartnerPrefs;